import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import styled from 'styled-components';

import BackButton from '../custom/BackButton';
import ActionIcon from '../custom/ActionIcon';
import { useRecoilState } from 'recoil';
import { confirmationModalState } from './useConfirmation';

export default function ConfirmationModal () {

    const [state, setState] = useRecoilState(confirmationModalState);
    const toggle = () => setState(prev => {
        return {
            ...prev,
            modal: false
        }
    });

    const handleConfirmation = () => {
        state.confirmationFunction();
        toggle();
    }

    return (
        <Modal isOpen={state.modal} toggle={toggle}>
            <ModalHeader className={'d-flex'}>
                <HeaderContainer>
                    <BackButton onClick={toggle} />
                    <h4 className={'pl-2'}>{state.text}</h4>
                </HeaderContainer>
            </ModalHeader>
            <ModalBody>
                <FooterButtonsContainer update>
                    <ActionIcon 
                        type={'cancel'} 
                        onClick={toggle} 
                    />
                    <ActionIcon 
                        type={'check'} 
                        onClick={handleConfirmation} 
                    />
                </FooterButtonsContainer>
            </ModalBody>
        </Modal>
    );
}

const HeaderContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
`;

const ExpandedFooter = styled(ModalFooter)`
    width: 100%;
`;

const FooterContentContainer = styled.div`
    width: 100%;
`;

const FooterButtonsContainer = styled.div<{update?: boolean}>`
    width: 100%;
    display: flex;
    justify-content: ${p => p.update ? 'space-between' : 'flex-end'};
`;